import EmptyListItem from './EmptyListItem';

export default EmptyListItem;
